import React from "react";
import Button from "../../Button/Button";
import Modal from "../Modal/Modal";
import styles from "./CancelOrder.module.scss";

const CancelOrder = ({ show, handleClose, handleCancelSubmit }) => {
  return (
    <Modal
      show={show}
      handleClose={handleClose}
      title="Cancel Order"
      className={styles.cancel}
    >
      <h4>Are you sure you want to cancel the order?</h4>
      <div className={styles.action}>
        <Button variant="bordered_grey" fluid onClick={handleClose}>
          No, Go Back
        </Button>
        <Button variant="danger_filled" fluid onClick={handleCancelSubmit}>
          Yes
        </Button>
      </div>
    </Modal>
  );
};

export default CancelOrder;
